<script>
import {authenticationMethods, notificationMethods} from "@/state/helpers";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import {mapState} from "vuex";
import {email, required} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Register",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout},
  data() {
    return {
      user: {username: "", first_name: "", last_name: "", email: "", password: ""},
      submitted: false,
      registerSuccess: false
    };
  },
  validations: {
    user: {
      username: {required},
      first_name: {required},
      last_name: {required},
      email: {required, email},
      password: {required}
    }
  },
  computed: {
    ...mapState("authentication", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    }
  },
  methods: {
    ...authenticationMethods,
    ...notificationMethods,
    tryToRegisterIn() {
      this.submitted = true;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const {email, username, password} = this.user;
        if (email && username && password) {
          this.register(this.user);
        }
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Free Register</h5>
                  <p>Get your free Orbiter account.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt class="rounded-circle" height="34"/>
                  </span>
                </div>
              </router-link>
            </div>

            <b-alert
                v-model="registerSuccess"
                class="mt-3"
                variant="success"
                dismissible
            >Registration successfull.
            </b-alert>

            <div
                v-if="notification.message"
                :class="'alert ' + notification.type"
            >{{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToRegisterIn">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group class="mb-3" id="email-group" label="First name" label-for="first_name">
                    <b-form-input
                        id="first_name"
                        v-model="user.first_name"
                        type="text"
                        placeholder="Enter first name"
                        :class="{ 'is-invalid': submitted && $v.user.first_name.$error }"
                    ></b-form-input>
                    <div
                        v-if="submitted && !$v.user.first_name.required"
                        class="invalid-feedback"
                    >First name is required.
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group class="mb-3" id="email-group" label="Last name" label-for="last_name">
                    <b-form-input
                        id="last_name"
                        v-model="user.last_name"
                        type="text"
                        placeholder="Enter last name"
                        :class="{ 'is-invalid': submitted && $v.user.last_name.$error }"
                    ></b-form-input>
                    <div
                        v-if="submitted && !$v.user.last_name.required"
                        class="invalid-feedback"
                    >Last name is required.
                    </div>
                  </b-form-group>
                </div>
              </div>

              <b-form-group class="mb-3" id="email-group" label="Username" label-for="username">
                <b-form-input
                    id="username"
                    v-model="user.username"
                    type="text"
                    placeholder="Enter username"
                    :class="{ 'is-invalid': submitted && $v.user.username.$error }"
                ></b-form-input>
                <div
                    v-if="submitted && !$v.user.username.required"
                    class="invalid-feedback"
                >Username is required.
                </div>
              </b-form-group>

              <b-form-group class="mb-3" id="fullname-group" label="Email" label-for="email">
                <b-form-input
                    id="email"
                    v-model="user.email"
                    type="email"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                ></b-form-input>
                <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                  <span v-if="!$v.user.email.required">Email is required.</span>
                  <span v-if="!$v.user.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group class="mb-3" id="password-group" label="Password" label-for="password">
                <b-form-input
                    id="password"
                    v-model="user.password"
                    type="password"
                    placeholder="Enter password"
                    :class="{ 'is-invalid': submitted && $v.user.password.$error }"
                ></b-form-input>
                <div
                    v-if="submitted && !$v.user.password.required"
                    class="invalid-feedback"
                >Password is required.
                </div>
              </b-form-group>

              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block">Register</b-button>
              </div>

              <div class="mt-4 text-center">
                <p class="mb-0">
                  By registering you agree to the Orbiter
                  <a href="javascript: void(0);" class="text-primary">Terms of Use</a>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="mt-5 text-center">
          <p>
            Already have an account ?
            <router-link tag="a" to="/login" class="fw-medium text-primary">Login</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} Orbiter. Crafted with <i class="mdi mdi-heart text-danger"></i> by
            <a target="_blank" href="https://jorrit.pro/">Jorrit</a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module></style>
